import { GrClose } from 'react-icons/gr';

import { RiPencilRulerLine } from 'react-icons/ri';

import {
  FaBed,
  FaBath,
} from 'react-icons/fa';

import {
  BsCheckCircle,
  BsFillCalendarCheckFill,
} from 'react-icons/bs';

import {
  AiOutlineWhatsApp,
} from 'react-icons/ai';

import { GiHomeGarage } from 'react-icons/gi';

export const iconsList = {
  GrClose,
  RiPencilRulerLine,
  FaBed,
  FaBath,
  BsFillCalendarCheckFill,
  GiHomeGarage,
  BsCheckCircle,
  AiOutlineWhatsApp,
}